import { defineStore } from 'pinia'
import { ref } from 'vue'
import apiService from '../services/apiService'
import logService from '../services/logService'
import { useUIStore } from './ui'

export const useDashboardStore = defineStore('dashboard', () => {
    const uiStore = useUIStore()

    // State
    const stats = ref([])
    const recentOrders = ref([])
    const recentActivity = ref([])
    const loading = ref(false)
    const error = ref(null)

    // Actions
    const fetchStats = async () => {
        try {
            loading.value = true
            error.value = null
            logService.info('Fetching dashboard statistics...')

            const response = await apiService.get('/dashboard/stats')

            if (response.success) {
                stats.value = response.data.stats
                recentOrders.value = response.data.recentOrders
                recentActivity.value = response.data.recentActivity
                logService.info('Dashboard stats loaded successfully')
            }
        } catch (err) {
            logService.error('Failed to fetch dashboard stats:', err)
            error.value = err.message
            uiStore.showNotification({
                type: 'error',
                title: 'Dashboard Error',
                message: 'Failed to load dashboard statistics.'
            })
        } finally {
            loading.value = false
        }
    }

    return {
        // State
        stats,
        recentOrders,
        recentActivity,
        loading,
        error,

        // Actions
        fetchStats
    }
})
